import { Tags } from "@/enum/tags";
import { apiSlice } from "../http";

export interface InvoiceSyncTriggerResponse {
  message: string;
  jobId: string;
}

export interface InvoiceSyncStatusResponse {
  queue: {
    waiting: number;
    active: number;
    completed: number;
    failed: number;
    delayed: number;
  };
  config: {
    cronExpression: string;
    defaultDaysBack: number;
  };
}

export interface InvoiceSyncTriggerParams {
  startDate: string;
  endDate: string;
}

export const invoiceSyncApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    triggerInvoiceSync: builder.mutation<InvoiceSyncTriggerResponse, InvoiceSyncTriggerParams>({
      query: ({ startDate, endDate }) => ({
        url: `invoice-sync/trigger?startDate=${startDate}&endDate=${endDate}`,
        method: "POST",
      }),
      invalidatesTags: [Tags.TAX_WORKFLOW],
    }),
    getInvoiceSyncStatus: builder.query<InvoiceSyncStatusResponse, void>({
      query: () => ({
        url: `invoice-sync/status`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useTriggerInvoiceSyncMutation,
  useGetInvoiceSyncStatusQuery,
  useLazyGetInvoiceSyncStatusQuery,
} = invoiceSyncApi;
